import { Link } from "react-router-dom";
import { SITE } from "./siteConfig";

const LogoMark = ({ gradientId }) => (
    <svg viewBox="0 0 40 40" width="40" height="40" focusable="false">
        <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#0B7A5C" />
                <stop offset="1" stopColor="#33836E" />
            </linearGradient>
        </defs>
        <rect width="40" height="40" rx="11" fill={`url(#${gradientId})`} />
        <path
            d="M11 13.5h18M14 19.5h12M17 25.5h6"
            stroke="#fff"
            strokeWidth="2.6"
            strokeLinecap="round"
        />
        <circle cx="20" cy="31" r="2" fill="#81D2BC" />
    </svg>
);

const Logo = ({ size, asLink = true }) => {
    const parts = SITE.brand.split(" ");
    const first = parts[0];
    const rest = parts.slice(1).join(" ");
    const gradientId = `lgm-${size || "def"}`;

    const content = (
        <>
            <span className="logo__mark" aria-hidden="true">
                <LogoMark gradientId={gradientId} />
            </span>
            <span className="logo__text">
                <b className="logo__name">
                    <i>{first}</i>
                    {rest ? ` ${rest}` : ""}
                </b>
            </span>
        </>
    );

    const className = `logo${size ? ` logo--${size}` : ""}`;

    if (!asLink) {
        return (
            <span className={className} aria-label={SITE.brand}>
                {content}
            </span>
        );
    }

    return (
        <Link to="/" className={className} aria-label={SITE.brand}>
            {content}
        </Link>
    );
};

export default Logo;
